import { render, staticRenderFns } from "./waiter_list.vue?vue&type=template&id=67997fca&scoped=true"
import script from "./waiter_list.vue?vue&type=script&lang=js"
export * from "./waiter_list.vue?vue&type=script&lang=js"
import style0 from "./waiter_list.vue?vue&type=style&index=0&id=67997fca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67997fca",
  null
  
)

export default component.exports